export interface IAutoFocus {
  autofocus?: boolean;
}
